module.exports = __webpack_public_path__ + "img/b6_lanjingxunhang.391cb1b5.jpg";